<div class="spinkit" style="overflow: hidden;">
    <ng-container [ngSwitch]="type$">

        <sk-chasing-dots    [color]="color$" [size]="size$" *ngSwitchCase="types$.ChasingDot"></sk-chasing-dots>
        <sk-circle          [color]="color$" [size]="size$" *ngSwitchCase="types$.Circle"></sk-circle>
        <sk-cube-grid       [color]="color$" [size]="size$" *ngSwitchCase="types$.CubeGrid"></sk-cube-grid>
        <sk-double-bounce   [color]="color$" [size]="size$" *ngSwitchCase="types$.DoubleBounce"></sk-double-bounce>
        <sk-fading-circle   [color]="color$" [size]="size$" *ngSwitchCase="types$.FadingCircle"></sk-fading-circle>
        <sk-folding-cube    [color]="color$" [size]="size$" *ngSwitchCase="types$.FoldingCube"></sk-folding-cube>
        <sk-pulse           [color]="color$" [size]="size$" *ngSwitchCase="types$.Pulse"></sk-pulse>
        <sk-rotating-plane  [color]="color$" [size]="size$" *ngSwitchCase="types$.RotatingPlane"></sk-rotating-plane>
        <sk-three-bounce    [color]="color$" [size]="size$" *ngSwitchCase="types$.ThreeBounce"></sk-three-bounce>
        <sk-wandering-cubes [color]="color$" [size]="size$" *ngSwitchCase="types$.WanderingCubes"></sk-wandering-cubes>
        <sk-wave            [color]="color$" [size]="size$" *ngSwitchCase="types$.Wave"></sk-wave>
        <sk-word-press      [color]="color$" [size]="size$" *ngSwitchCase="types$.WordPress"></sk-word-press>

    </ng-container>
</div>
